export const FETCH_STONE_SIZE_REQUEST = 'FETCH_STONE_SIZE_REQUEST';
export const FETCH_STONE_SIZE_SUCCESS = 'FETCH_STONE_SIZE_SUCCESS';
export const FETCH_STONE_SIZE_FAILURE = 'FETCH_STONE_SIZE_FAILURE';

export const ADD_STONE_SIZE_REQUEST = 'ADD_STONE_SIZE_REQUEST';
export const ADD_STONE_SIZE_SUCCESS = 'ADD_STONE_SIZE_SUCCESS';
export const ADD_STONE_SIZE_FAILURE = 'ADD_STONE_SIZE_FAILURE';

export const UPDATE_STONE_SIZE_REQUEST = 'UPDATE_STONE_SIZE_REQUEST';
export const UPDATE_STONE_SIZE_SUCCESS = 'UPDATE_STONE_SIZE_SUCCESS';
export const UPDATE_STONE_SIZE_FAILURE = 'UPDATE_STONE_SIZE_FAILURE';

export const DELETE_STONE_SIZE_REQUEST = 'DELETE_STONE_SIZE_REQUEST';
export const DELETE_STONE_SIZE_SUCCESS = 'DELETE_STONE_SIZE_SUCCESS';
export const DELETE_STONE_SIZE_FAILURE = 'DELETE_STONE_SIZE_FAILURE';

export const STONE_SIZE_FORM_ERROR = 'STONE_SIZE_FORM_ERROR';
export const STONE_SIZE_FORM_SUCCESS = 'STONE_SIZE_FORM_SUCCESS';
export const SET_STONE_SIZE_EDIT = 'SET_STONE_SIZE_EDIT';
export const CLEAR_STONE_SIZE_EDIT = 'CLEAR_STONE_SIZE_EDIT'; 